import React from 'react';
import { ProjectSetting } from '../../Components/ProjectSettings/ProjectSetting';

function WorkspaceProjectSettingsPage({ project }) {
    return (
        <ProjectSetting
            project={project}
            isAccessedInIframe={true} />
    )
}

export default WorkspaceProjectSettingsPage;